export default [
  {
    path: '/app/defines/product-config',
    name: 'ProductConfig',
    component: () => import('@/views/Admin/Defines/Product_config/Index.vue'),
    meta: {
      pageTitle: 'Ürün Tanımları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_CONFIG',
      action: 'read',
    },
  },
  {
    path: '/app/defines/product-config/add',
    name: 'ProductConfigAdd',
    component: () => import('@/views/Admin/Defines/Product_config/Add.vue'),
    meta: {
      pageTitle: 'Ürün Tanımları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/product-config',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_CONFIG',
      action: 'read',
    },
  },
  {
    path: '/app/defines/product-config/edit/:id',
    name: 'ProductConfigEdit',
    component: () => import('@/views/Admin/Defines/Product_config/Edit.vue'),
    meta: {
      pageTitle: 'Ürün Tanımları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/defines/product-config',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_CONFIG',
      action: 'read',
    },
  },
]
